<template>
  <div class="container">
    <h3>{{ $t('phrase.register_research') }}</h3>
    <div class="card card-body mb-2">
      <div class="row">
        <div class="col-md-6">
          <v-single-select
            v-model="organisationSlug"
            label="word.organisation"
            :add-empty-choice="true"
            :choices="organisations"
            :required="true"
            :translate-text="false"
          />
        </div>
        <div class="col-md-6" v-if="organisationSlug">
          <v-single-select
            v-model="researchTypeSlug"
            label="word.research_type"
            :add-empty-choice="true"
            :choices="researchTypes"
            :required="true"
            :translate-text="false"
          />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <v-button
        text="word.next"
        @click="submit"
        :disabled="!organisationSlug || !researchTypeSlug"
        :loader="loader"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import SingleSelect from '@/common/components/inputs/SingleSelect.vue';
import { createOrganisationMembership, fetchOrganisations } from '@/admin/api';
import { fetchResearchTypes } from '@/organisation/api';

export default {
  name: 'ResearchCreate',
  components: {
    'v-button': Button,
    'v-single-select': SingleSelect,
  },
  methods: {
    async fetchOrganisations() {
      const response = await fetchOrganisations();
      this.organisations = response.data.map((organisation) => ({
        key: organisation.slug,
        value: organisation.name,
      }));
    },
    async fetchResearchTypes() {
      const response = await fetchResearchTypes();
      this.researchTypes = response.data.map((researchType) => ({
        key: researchType.slug,
        value: `${researchType.name} (Eur. ${researchType.initial_price || '-'})`,
      }));
    },
    async submit() {
      this.loader.loading = true;
      const response = await createOrganisationMembership(this.organisationSlug);
      if (response.status === 201) {
        this.loader.loading = false;
        document.location.href = `/organisation/create-research/${this.researchTypeSlug}/`;
      } else {
        this.loader.loading = false;
        alert('Something went wrong, please try again later.');
      }
    },
  },
  data() {
    return {
      organisations: [],
      researchTypes: [],
      loader: { loading: false },
      organisationSlug: null,
      researchTypeSlug: null,
    };
  },
  created() {
    this.fetchOrganisations();
    this.fetchResearchTypes();
  },
};
</script>
